export default __webpack_public_path__ + "static/media/JoinStop.fe7529a9.svg";